import { Category } from '@fcom/dapi/api/models';

export const ENABLED_PAX_ANCILLARY_CATEGORIES = [Category.BAGGAGE, Category.LOUNGE];
